import { z } from "zod";
import { apiBuilder, prefixApi } from "@zodios/core";
import { datasetFilterSchema, dspDatasetsPaginationSchema } from "./common";

const dspGeoMetricFields = {
  add_to_cart_clicks: z.number(),
  add_to_cart_clicks_prev: z.number().nullable().optional(),
  add_to_cart_clicks_delta: z.number().nullable().optional(),
  add_to_cart_clicks_percent: z.number().nullable().optional(),

  total_detail_page_view: z.number(),
  total_detail_page_view_prev: z.number().nullable().optional(),
  total_detail_page_view_delta: z.number().nullable().optional(),
  total_detail_page_view_percent: z.number().nullable().optional(),

  total_add_to_cart: z.number(),
  total_add_to_cart_prev: z.number().nullable().optional(),
  total_add_to_cart_delta: z.number().nullable().optional(),
  total_add_to_cart_percent: z.number().nullable().optional(),

  new_to_brand_detail_page_views: z.number(),
  new_to_brand_detail_page_views_prev: z.number().nullable().optional(),
  new_to_brand_detail_page_views_delta: z.number().nullable().optional(),
  new_to_brand_detail_page_views_percent: z.number().nullable().optional(),

  total_new_to_brand_dpvs: z.number(),
  total_new_to_brand_dpvs_prev: z.number().nullable().optional(),
  total_new_to_brand_dpvs_delta: z.number().nullable().optional(),
  total_new_to_brand_dpvs_percent: z.number().nullable().optional(),

  total_units_sold: z.number(),
  total_units_sold_prev: z.number().nullable().optional(),
  total_units_sold_delta: z.number().nullable().optional(),
  total_units_sold_percent: z.number().nullable().optional(),
};

const dspGeoRowSchema = z.object({
  country: z.string(),
  region: z.string(),
  ...dspGeoMetricFields,
});

export type DSPGeoRow = z.infer<typeof dspGeoRowSchema>;

const dspGeoQueryRequestSchema = z.object({
  model: z.literal("dspgeo"),
  dimensions: z.union([z.string(), z.array(z.string())]),
  filters: z.array(datasetFilterSchema).optional().default([]),
  sort: z.string().optional(),
  page: z.number().optional(),
  limit: z.number().optional(),
  include_count: z.boolean().optional(),
});

const dspGeoQueryResponseSchema = z.object({
  data: z.array(dspGeoRowSchema),
  pagination: dspDatasetsPaginationSchema,
});

export const dspGeoDatasetsApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    method: "post",
    path: "/datasets/query/?geo",
    alias: "dspGeoDatasetsQuery",
    description: "Query geo datasets by dimensions + filters",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: dspGeoQueryRequestSchema,
      },
    ],
    response: dspGeoQueryResponseSchema,
  }).build(),
);
